import {Component, OnInit} from '@angular/core';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Constant} from '../../../../global/util/Constant';
import {Partner} from '../../../model/Partner';
import {Workflow} from '../../../model/Workflow';
import {Enterprise} from '../../../model/Enterprise';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../service/auth/auth.service';
import {SignatureReportService} from '../../../service/signature-report.service';
import {TotalServiceReport} from '../../../model/TotalServiceReport';
import {Dialog} from '../../../../global/util/Dialog';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../../../global/util/enum/InformType';
import {Router} from '@angular/router';
import {TotalServiceReportDetail} from '../../../model/TotalServiceReportDetail';
import {EnterpriseService} from '../../../service/enterprise.service';
import {WorkflowService} from '../../../service/workflow.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';


@Component({
  selector: 'app-services-report',
  templateUrl: './services-report.component.html',
  styleUrls: ['./services-report.component.css']
})
export class ServicesReportComponent implements OnInit {
  public loading: boolean;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ADMIN_IOFE = Constant.ADMIN_IOFE;
  public totalServiceReports: TotalServiceReport[] = [];
  public partners: Partner[] = [];
  public workflows: Workflow[] = [];
  public enterprises: Enterprise[] = [];
  public workflowSelected: Workflow;
  public enterpriseSelected: Enterprise;
  public partnerSelected: Partner;
  public enterpriseIdSelected: number;
  public reportForm: FormGroup;
  public partnerId: number;
  public enterpriseId: number;
  public workflowId: number;
  public dateStart: string;
  public dateEnd: string;

  constructor(private formBuilder: FormBuilder,
              public signatureReportService: SignatureReportService,
              private modalService: NgbModal,
              private router: Router,
              private enterpriseService: EnterpriseService,
              private workflowService: WorkflowService,
              private enterpriseDataService: EnterpriseDataService,
              private authenticationService: AuthService) {
    Dialog.createInstance(modalService);
    this.createForm();
  }

  ngOnInit(): void {
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.reportForm.patchValue({enterprise: this.enterpriseSelected});
    this.loadDefaultData();
    this.reportForm.get('partner').valueChanges.subscribe(partner => {
      if (partner) {
        this.getEnterpriseBy(partner.id);
        localStorage.setItem('selectedPartner', JSON.stringify(partner));
      }
    });

    this.reportForm.get('enterprise').valueChanges.subscribe(enterprise => {
      if (enterprise) {
        this.loadWorkflow(enterprise.id);
        localStorage.setItem('selectedEnterprise', JSON.stringify(enterprise));
      }
    });

    this.reportForm.get('workflow').valueChanges.subscribe(workflow => {
      localStorage.setItem('selectedWorkflow', JSON.stringify(workflow));
    });

    this.reportForm.get('dateStart').valueChanges.subscribe(dateStart => {
      localStorage.setItem('selectedDateStart', dateStart);
    });

    this.reportForm.get('dateEnd').valueChanges.subscribe(dateEnd => {
      localStorage.setItem('selectedDateEnd', dateEnd);
    });
  }

  private loadDefaultData() {
    this.workflows = LocalStorage.getDefaultWorkflows();
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];

    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ADMIN_IOFE)) {
      this.partners = LocalStorage.getPartnersExtra();
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.reportForm.patchValue({partner: this.partnerSelected});
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(partnerId);
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
      this.loadWorkflow(this.enterpriseIdSelected);
    }
    // this.loadWorkflow();
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.reportForm.patchValue({workflow: this.workflowSelected});
    this.loadConsolidatedServices();
  }

  private loadWorkflow(enterpriseId: number) {
    this.workflowService.getWorkflowsExtraBy(enterpriseId).subscribe((workflows: Workflow[]) => {
      const workflowsFilter = workflows.filter((workflow: Workflow) => (workflow.enterpriseId === enterpriseId) && workflow.ready2Use === Constant.READY_TO_USE);
      this.workflows = [{
        id: 0,
        description: 'TODOS'
      }, ...workflowsFilter];
      this.reportForm.patchValue({
        workflow: this.workflows[0]
      });
      localStorage.setItem('selectedWorkflow', JSON.stringify(this.workflows[0]));
    });
  }

  private createForm() {
    const savedPartner = localStorage.getItem('selectedPartner');
    const savedEnterprise = localStorage.getItem('selectedEnterprise');
    const savedWorkflow = localStorage.getItem('selectedWorkflow');
    const savedDateStart = localStorage.getItem('selectedDateStart');
    const savedDateEnd = localStorage.getItem('selectedDateEnd');

    // Si hay datos guardados, usarlos para inicializar el formulario
    this.reportForm = this.formBuilder.group({
      partner: [savedPartner ? JSON.parse(savedPartner).id : 0],
      enterprise: [savedEnterprise ? JSON.parse(savedEnterprise).id : 0],
      workflow: [savedWorkflow ? JSON.parse(savedWorkflow).id : 0],
      dateStart: [savedDateStart || this.getCurrentDate(), [Validators.required]],
      dateEnd: [savedDateEnd || this.getCurrentDate(), [Validators.required]]
    });
  }

  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2); // Se suma 1 porque los meses van de 0 a 11
    const day = ('0' + today.getDate()).slice(-2); // Asegura que el día tenga dos dígitos
    return `${year}-${month}-${day}`;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  public loadConsolidatedServices() {
    const savedPartner = localStorage.getItem('selectedPartner');
    const savedEnterprise = localStorage.getItem('selectedEnterprise');
    const savedWorkflow = localStorage.getItem('selectedWorkflow');

    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ADMIN_IOFE)) {
      this.partnerId = savedPartner ? JSON.parse(savedPartner).id : this.reportForm.get('partner')?.value.id;
      // this.enterpriseId = savedEnterprise ? JSON.parse(savedEnterprise).id : this.reportForm.get('enterprise')?.value.id;
      const enterprise = this.reportForm.get('enterprise')?.value;
      this.enterpriseId = savedEnterprise ? JSON.parse(savedEnterprise).id : (enterprise?.id ?? 0);
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.partnerId = savedPartner ? JSON.parse(savedPartner).id : LocalStorage.getPartnerId();
      const enterprise = this.reportForm.get('enterprise')?.value;
      this.enterpriseId = savedEnterprise ? JSON.parse(savedEnterprise).id : (enterprise?.id ?? 0);
    } else {
      this.partnerId = savedPartner ? JSON.parse(savedPartner).id : LocalStorage.getPartnerId();
      this.enterpriseId = savedEnterprise ? JSON.parse(savedEnterprise).id : LocalStorage.getEnterpriseId();
    }
    // this.workflowId = savedWorkflow ? JSON.parse(savedWorkflow).id : this.reportForm.get('workflow')?.value.id;
    const workflow = this.reportForm.get('workflow')?.value;
    this.workflowId = savedWorkflow ? JSON.parse(savedWorkflow).id : (workflow?.id ?? 0);
    this.dateStart = this.reportForm.get('dateStart')?.value;
    this.dateEnd = this.reportForm.get('dateEnd')?.value;
    const url = Constant.ROOT_API_V1.concat('/totalReportService/search?',
      'partnerId=', String(this.partnerId),
      '&enterpriseId=', String(this.enterpriseId),
      '&workflowId=', String(this.workflowId),
      '&dateFrom=', this.dateStart,
      '&dateTo=', this.dateEnd);
    this.getTotalServiceReport(url);
  }

  private getTotalServiceReport(url: string) {
    this.hasNotCorrectDateRange();
    this.loading = true;
    this.signatureReportService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next) {
        this.totalServiceReports = next.consolidatedDetails;
      } else {
        this.totalServiceReports = [];
      }
    }, () => {
      this.loading = false;
    });
  }

  public downloadReport() {
    this.hasNotCorrectDateRange();
    const url = Constant.ROOT_API_V1.concat('/totalReportService/search/report?',
      'partnerId=', String(this.partnerId),
      '&enterpriseId=', String(this.enterpriseId),
      '&workflowId=', String(this.workflowId),
      '&dateFrom=', this.dateStart,
      '&dateTo=', this.dateEnd);
    this.loading = true;
    this.signatureReportService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = 'Reporte de servicios';
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  public getDetailServiceReport(totalServiceReport: TotalServiceReport) {
    const url = Constant.ROOT_API_V1.concat('/totalReportServiceDetail/search?',
      'partnerId=', String(this.partnerId),
      '&enterpriseId=', String(this.enterpriseId),
      '&workflowId=', String(this.workflowId),
      '&dateFrom=', this.dateStart,
      '&dateTo=', this.dateEnd,
      '&level=', String(totalServiceReport.level),
      '&hasTSA=', String(totalServiceReport.tsa),
      '&typeSignature=', String(totalServiceReport.id));
    this.loading = true;
    this.signatureReportService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next) {
        const totalServiceReportDetail: TotalServiceReportDetail[] = next.totalServiceReportDetail;
        if (totalServiceReportDetail.length > 0) {
          this.router.navigate(['service-report-detail'], {
            state: {
              totalServiceReportDetail, totalServiceReport,
              partnerId: this.partnerId, enterpriseId: this.enterpriseId, workflowId: this.workflowId,
              dateStart: this.dateStart, dateEnd: this.dateEnd
            }
          }).then();
        } else {
          Dialog.show(InformType.Warning, 'Reporte de Servicios', 'No existe detalle que mostrar, seleccione otro valor.');
        }
      } else {
        this.totalServiceReports = [];
      }
    }, () => {
      this.loading = false;
    });
  }

  public hasNotCorrectDateRange() {
    let dateStart = this.dateStart;
    let dateEnd = this.dateEnd;
    dateStart = dateStart.substring(0, dateStart.length);
    dateEnd = dateEnd.substring(0, dateEnd.length);
    const initialDate = new Date(dateStart);
    const endTime = new Date(dateEnd);
    const daysDiff = this.getDaysDifference(initialDate, endTime);
    if (daysDiff > 31) {
      Dialog.show(InformType.Warning, 'Reporte de Servicios', 'El rango de fechas seleccionado no puede superar los 31 días.');
    }
    if (initialDate > endTime) {
      Dialog.show(InformType.Warning, 'Reporte de Servicios', 'La fecha de inicio no puede ser posterior a la fecha de fin.');
    }
  }

  public getDaysDifference(firstDate: Date, secondDate: Date): number {
    const timeDiff = firstDate.getTime() - secondDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24)) * -1;
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.partnerSelected.id);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.reportForm.patchValue({enterprise: this.enterpriseSelected});
        localStorage.setItem('selectedEnterprise', JSON.stringify(this.enterprises[Constant.ZERO_INDEX]));
      }
    });
  }


  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseDataService.setEnterprises(this.enterprises);
      if (this.enterprises.length > 0) {
        this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
        this.reportForm.patchValue({enterprise: this.enterpriseSelected});
        localStorage.setItem('selectedEnterprise', JSON.stringify(this.enterprises[Constant.ZERO_INDEX]));
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.loadWorkflow(this.enterpriseSelected.id);
    }
  }
}
